import React, { useState } from "react";
import "./SearchFilter.css";

function SearchFilter({ 
  searchTerm, 
  filters, 
  onSearchChange, 
  onFilterChange, 
  onClearFilters,
  config = {} 
}) {
  const [isFilterExpanded, setIsFilterExpanded] = useState(false);
  
  const {
    searchPlaceholder = "Enter search criteria...",
    filterFields = [],
    title = "Search Filters"
  } = config;

  const handleFilterChange = (filterName, value) => {
    onFilterChange(filterName, value);
  };

  const toggleFilters = () => {
    setIsFilterExpanded(!isFilterExpanded);
  };

  const renderFilterField = (field) => {
    const { name, type, placeholder, options = [] } = field;
    
    if (type === 'select') {
      return (
        <select
          key={name}
          value={filters[name] || ''}
          onChange={(e) => handleFilterChange(name, e.target.value)}
          className="filter-select"
        >
          <option value="">{placeholder || 'All'}</option>
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      );
    }
    
    if (type === 'number') {
      return (
        <input
          key={name}
          type="number"
          placeholder={placeholder}
          value={filters[name] || ''}
          onChange={(e) => handleFilterChange(name, e.target.value)}
          className="filter-input"
        />
      );
    }
    
    return null;
  };

  return (
    <div className="search-filter-section">
      <div className="filter-header">
        <h6 className="filter-title">{title}</h6>
        <button 
          className="filter-toggle-btn"
          onClick={toggleFilters}
        >
          ☰
        </button>
      </div>
      
      <div className="search-bar">
        <input
          type="text"
          placeholder={searchPlaceholder}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="search-input"
        />
      </div>

      <div className={`filter-controls ${isFilterExpanded ? 'expanded' : ''}`}>
        {filterFields.map(field => renderFilterField(field))}
        
        <button 
          onClick={onClearFilters} 
          className="clear-filters-btn"
        >
          Clear Filters
        </button>
      </div>
    </div>
  );
}

export default SearchFilter;